import axios from "axios";

export default {
    state: () => ({
    }),
    mutations: {},
    getters: {},
    actions:{
        loadDistrictList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/district", {headers})
                .then((response) => {
                    return response.data;
                })
        },
        updateDistrict(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/district", request,{headers})
                .then((response) => {
                    return response.data;
                })

        },
        createDistrict(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/district", request,{headers})
                .then((response) => {
                    return response.data;
                })
        },
        deleteDistrict(context,request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/district/"+request.id,{headers})
                .then((response) => {
                    return response.data;
                })
        },
    }
}